import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackOpenChat } from './tracking';
import { getNewbuildingChatSrc } from './utils';
import { closeChat } from 'shared/actions/chat';
import { ChatPopup } from 'shared/components/ChatPopup';
import { usePrevious } from 'shared/hooks/usePrevious';
import { getNewbuildingInformation } from 'shared/selectors/newbuildingHeader';
import { selectNewbuildingLayoutDetailsModalOpen } from 'shared/selectors/newbuildingLayouts';
import { selectChat } from 'shared/selectors/selectChat';
import { INewbuilding } from 'shared/types/newbuildingHeader';

import type { TContactParam } from '@cian/newbuilding-chat-component';

export const NewbuildingChatPopupContainer: React.FC = () => {
  const dispatch = useDispatch();

  const { isOpened, newbuildingContact, placeType } = useSelector(selectChat);
  const newbuilding = useSelector(getNewbuildingInformation) as INewbuilding;
  const isLayoutDetailsModalOpen = useSelector(selectNewbuildingLayoutDetailsModalOpen);

  const previousOpened = usePrevious(isOpened);

  React.useEffect(() => {
    if (!previousOpened && isOpened) {
      trackOpenChat({ newbuildingId: newbuilding.id ?? 0, placeType });
    }
  }, [previousOpened, isOpened, newbuilding.id, placeType]);

  const onClose = React.useCallback(() => dispatch(closeChat()), [dispatch]);

  if (!isOpened) {
    return null;
  }

  const src = getNewbuildingChatSrc(newbuildingContact as TContactParam);

  return <ChatPopup src={src} onClose={onClose} aboveModal={isLayoutDetailsModalOpen} />;
};
